import MerchantsIcon from '@material-ui/icons/Storefront';

import MerchantsList from './MerchantsList';
import MerchantsEdit from './MerchantsEdit';
// import MerchantsCreate from './MerchantsCreate';


export default {
    list: MerchantsList,
    edit: MerchantsEdit,
    // create: MerchantsCreate,
    icon: MerchantsIcon,
};
